export const UrlConfigPublic = {
  login: "/login",
  register: "/register",
  loginRoot: "/loginRoot",
  SendLinkRecoverPassword: "/SendLinkRecoverPassword",
  RecoverPassword: "/RecoverPassword/:id",
};
